import { Button, makeStyles, Text, Title1 } from "@fluentui/react-components";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const useStyles = makeStyles({
    root: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "80vh",
        textAlign: "center",
        background: "url('/video/top-banner-video-preview.jpg') no-repeat center center",
    },
    container: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        width: "100%",
        textAlign: "center",
        color: "white",
        backgroundColor: "rgba(0, 0, 0, 0.67)",
    }
});

export default function NotFound() {
    const { t } = useTranslation("general");
    const styles = useStyles();

    return (
        <div className={styles.root}>
            <div className={styles.container}>
                <Title1 block as="h1" className="text-4xl font-bold">
                    {t("pageNotFound.title")}
                </Title1>
                <Text block as="p" className="mt-2">
                    {t("pageNotFound.description")}
                </Text>
                <Link to="/">
                    <Button appearance="primary">
                        {t("pageNotFound.backToHome")}
                    </Button>
                </Link>
            </div>
        </div>
  );
}